import React, { Component } from "react";
import { HotKeys } from "react-hotkeys";
import { FirestoreCollection, withFirestore } from "react-firestore";

import Link from "./Link";

const map = {
  undo: ["command+z", "control+z"],
  archive: "a",
  delete: ["del", "backspace", "d"],
  down: ["j", "down"],
  up: ["k", "up"],
  open: ["enter"],
  edit: ["i", "/"],
};

class LinksPage extends Component {
  state = { focused: false, selectedIndex: 0, actions: [] };

  setSelectedIndex = index => {
    const { links } = this.props;
    this.setState(
      {
        selectedIndex: Math.max(0, Math.min(links.length - 1, index)),
      },
      () => {
        this.selectedLinkNode.scrollIntoViewIfNeeded();
      }
    );
  };

  updateLink = ({ id, ...params }) => {
    console.log("updating");
    const doc = this.props.firestore.doc(`links/${id}`);
    return doc.update(params);
  };

  deleteLink = ({ id, ...link }) => {
    console.log(`deleting ${id}`);
    const undo = `firebase.firestore().doc("links/${id}").set(${JSON.stringify(
      link
    )})`;

    const doc = this.props.firestore.doc(`links/${id}`);
    doc.delete().then(() => {
      this.setState(({ actions }) => {
        return { actions: [...actions, undo] };
      });
    });
  };

  archiveLink = ({ id }) => {
    console.log(`archiving ${id}`);
    const undo = `firebase.firestore().doc("links/${id}").update({archivedAt: null})`;

    this.updateLink({ id, archivedAt: new Date() }).then(() => {
      this.setState(({ actions }) => {
        return { actions: [...actions, undo] };
      });
    });
  };

  undo = () => {
    // console.log("undoing");
    this.setState(({ actions }) => {
      const action = actions[actions.length - 1];
      eval(action);
      return { actions: actions.slice(0, -1) };
    });
  };

  render() {
    const { links } = this.props;
    const { focused, selectedIndex, actions } = this.state;
    const selectedLink = links[selectedIndex];

    if (links.length === 0) return "0 links :(";

    const handlers = {
      undo: e => {
        if (focused) return;
        this.undo();
      },
      delete: e => {
        if (focused) return;
        this.deleteLink(selectedLink);
      },
      archive: e => {
        if (focused) return;
        this.archiveLink(selectedLink);
      },
      open: e => {
        if (focused) return;
        // console.log(`visiting ${selectedLink.url}`);
        const win = window.open(selectedLink.url, "_blank");
        win.focus();
      },
      down: e => {
        if (focused) return;
        this.setSelectedIndex(selectedIndex + 1);
      },
      up: e => {
        if (focused) return;
        this.setSelectedIndex(selectedIndex - 1);
      },
      edit: e => {
        if (focused) return;
        e.preventDefault();
        this.selectedLink.textarea.focus();
      },
    };

    return (
      <HotKeys keyMap={map} handlers={handlers} focused={true}>
        <div className="list-group">
          {links.map((link, index) => (
            <Link
              key={link.id}
              {...link}
              destroy={() => this.deleteLink(link)}
              archive={() => this.archiveLink(link)}
              isSelected={index === selectedIndex}
              onClick={() => this.setState({ selectedIndex: index })}
              onFocus={() => this.setState({ focused: true })}
              onBlur={() => this.setState({ focused: false })}
              onUpdate={this.updateLink}
              ref={ref => {
                if (index === selectedIndex) this.selectedLink = ref;
              }}
              onRender={ref => {
                if (index === selectedIndex) this.selectedLinkNode = ref;
              }}
            />
          ))}
        </div>
        {actions.length > 0 && (
          <button
            className="btn btn-outline-secondary"
            style={{
              position: "fixed",
              bottom: 10,
              right: 10,
              backgroundColor: "white",
            }}
            onClick={this.undo}
          >
            undo
          </button>
        )}
      </HotKeys>
    );
  }
}

const LinksPageWithFirestore = withFirestore(LinksPage);

export default () => (
  <FirestoreCollection
    path={"links"}
    limit={20}
    filter={["archivedAt", "==", null]}
    // filter={["archivedAt", "<=", new Date()]}
    render={({ isLoading, data }) => {
      if (isLoading) return "Loading...";
      return <LinksPageWithFirestore links={data} />;
    }}
  />
);



// WEBPACK FOOTER //
// ./src/LinksPage.js